import Cookies from 'js-cookie';
import { hasFunctionalConsent } from './consent';

export const REFERRAL_COOKIE_NAME = 'referral';
export const REFERRAL_COOKIE_EXPIRY = 30; // days

export const saveReferralToCookie = (referralCode) => {
    if (!referralCode) return;
    
    // Check consent before setting functional cookies
    if (!hasFunctionalConsent()) {
        console.log('Referral cookie not saved - no functional consent');
        return;
    }
    
    try {
        Cookies.set(REFERRAL_COOKIE_NAME, referralCode, { 
            expires: REFERRAL_COOKIE_EXPIRY,
            sameSite: 'Lax',
            secure: window.location.protocol === 'https:'
        });
        console.log('Referral cookie saved:', referralCode);
    } catch (error) {
        console.error('Error saving referral code to cookie:', error);
    }
};

export const getReferralFromCookie = () => {
    try {
        return Cookies.get(REFERRAL_COOKIE_NAME);
    } catch (error) {
        console.error('Error getting referral code from cookie:', error);
        return null;
    }
};

export const clearReferralCookie = () => {
    try {
        Cookies.remove(REFERRAL_COOKIE_NAME);
    } catch (error) {
        console.error('Error clearing referral cookie:', error);
    }
};